// src/modules/competition/components/CompetitionOverview/index.js
import React from 'react';
import { Container, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CompetitionDetails from '../CompetitionDetails';
import CompetitorCards from '../CompetitorCards';
import CompetitorsTable from '../CompetitorsTable';
import { useCompetitionJoin } from '../../hooks/useCompetitionJoin';

const CompetitionOverview = ({
    competitors,
    lowestCompetitor,
    currentPeriod,
    onUsernameClick,
    isUserJoined,
    competitionId,
    competitionName,
    pointTarget,
    ministerOfActivity,
    onJoinSuccess
}) => {
    const { joinCompetition, alert, showAlert, setShowAlert } = useCompetitionJoin(competitionId);
    // Modify the hook to accept a success callback
    const handleJoinCompetition = async () => {
        const success = await joinCompetition();
        if (success) {
            onJoinSuccess(); // Reload the data after successful join
        }
    };

    const validPointTarget = pointTarget || 0;

    return (
        <Container className="mt-3">
            {alert.show && showAlert && (
                <Alert
                    variant={alert.variant}
                    onClose={() => setShowAlert(false)}
                    dismissible
                >
                    {alert.message}
                </Alert>
            )}

            <CompetitionDetails
                currentPeriod={currentPeriod}
                pointTarget={validPointTarget}
                isUserJoined={isUserJoined}
                onJoinClick={handleJoinCompetition}
                competitionId={competitionId}
                competitionName={competitionName}
            />

            <CompetitorCards
                ministerOfActivity={ministerOfActivity}
                lowestCompetitor={lowestCompetitor}
            />

            <CompetitorsTable
                competitors={competitors}
                lowestCompetitor={lowestCompetitor}
                pointTarget={validPointTarget}
                onUsernameClick={onUsernameClick}
            />
        </Container>
    );
};

CompetitionOverview.propTypes = {
    competitors: PropTypes.arrayOf(PropTypes.shape({
        username: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        totalPoints: PropTypes.number.isRequired,
        meetsCriteria: PropTypes.bool.isRequired,
        progress: PropTypes.number.isRequired,
    })).isRequired,
    lowestCompetitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired,
    }),
    currentPeriod: PropTypes.shape({
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired,
    }).isRequired,
    onUsernameClick: PropTypes.func.isRequired,
    isUserJoined: PropTypes.bool.isRequired,
    competitionId: PropTypes.string.isRequired,
    competitionName: PropTypes.string.isRequired,
};

export default CompetitionOverview;